import { useState } from "react";
import { saveAs } from "file-saver";
import { Document, HeadingLevel, Packer, Paragraph, TextRun } from "docx";
import { Button, Modal, Radio } from "antd";

type Item = {
  text: string;
  sub_id: string;
  start_time: string;
  end_time: string;
};

type Props = {
  allSub: any;
};

function formatHMS(msLike: string | number): string {
  const ms = typeof msLike === "string" ? parseInt(msLike, 10) : msLike;
  if (Number.isNaN(ms)) return String(msLike);
  const totalSec = Math.floor(Math.max(0, ms) / 1000);
  const h = Math.floor(totalSec / 3600)
    .toString()
    .padStart(2, "0");
  const m = Math.floor((totalSec % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const s = (totalSec % 60).toString().padStart(2, "0");
  return `${h}:${m}:${s}`;
}

const exportDocx = async (
  data: Item[],
  mode: number,
  filename = "export.docx"
) => {
  const title = new Paragraph({
    heading: HeadingLevel.HEADING_1,
    spacing: { after: 200 },
    children: [
      new TextRun({
        text: `รายการข้อความทั้งหมด`,
        bold: true,
        color: "000000",
      }),
    ],
  });

  if (mode === 1) {
    const joined = data.map((d) => d.text).join(" ");
    const contentPara = new Paragraph({
      children: [new TextRun({ text: joined, size: 28 })],
      spacing: { line: 276 },
    });

    const doc = new Document({
      sections: [
        {
          properties: {},
          children: [title, contentPara],
        },
      ],
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, filename);
    return;
  }

  const lines = data.map((d) => {
    const t1 = formatHMS(d.start_time);
    const t2 = formatHMS(d.end_time);
    return new Paragraph({
      children: [
        new TextRun({ text: `${t1} - ${t2} : ` }),
        new TextRun({ text: d.text, size: 28 }),
      ],
      spacing: { after: 120 },
    });
  });

  const doc = new Document({
    sections: [
      {
        properties: {},
        children: [
          new Paragraph({
            heading: HeadingLevel.HEADING_1,
            spacing: { after: 200 },
            children: [
              new TextRun({
                text: `รายการข้อความพร้อมเวลา รวมทั้งหมด ${data.length.toLocaleString()} รายการ`,
                bold: true,
                color: "000000",
              }),
            ],
          }),
          ...lines,
        ],
      },
    ],
  });

  const blob = await Packer.toBlob(doc);
  saveAs(blob, filename);
};

const ExportDocx = (props: Props) => {
  const [isModal, setIsModal] = useState(false);
  const [valueRadio, setValueRadio] = useState<any>(1);

  return (
    <>
      <Modal
        open={isModal}
        title="Export Text"
        onCancel={() => setIsModal(false)}
        onOk={() => {
          const timestamp = Date.now();
          exportDocx(props.allSub, valueRadio, `export_text_${timestamp}.docx`);
          setValueRadio(1);
          setIsModal(false);
        }}
      >
        <Radio.Group
          onChange={(e: any) => setValueRadio(e.target.value)}
          value={valueRadio}
          options={[
            { value: 1, label: "text-only" },
            { value: 2, label: "text and timestamp" },
          ]}
        />
      </Modal>
      <Button type={"primary"} onClick={() => setIsModal(true)}>
        Export
      </Button>
    </>
  );
};

export default ExportDocx;
